/** Identity changes invalidate consultation facts; the server still authorizes every action. */
import { useEffect, useState } from 'react';
import { getSupabaseBrowserClient } from '@/lib/supabase';
import { useDashboardMeContext } from '@/dashboard/me-context';
export function useConsultationIdentity(): string | undefined {
  const me = useDashboardMeContext()?.me;
  const [actor, setActor] = useState<string | null>(import.meta.env.DEV ? 'development' : null);
  useEffect(() => {
    const client = getSupabaseBrowserClient();
    if (!client) return;
    let active = true;
    let eventSeen = false;
    void client.auth.getSession().then(({ data }) => {
      if (active && !eventSeen) setActor(data.session?.user.id ?? null);
    }).catch(() => { if (active && !eventSeen) setActor(null); });
    const { data: { subscription } } = client.auth.onAuthStateChange((_event, session) => {
      eventSeen = true;
      if (active) setActor(session?.user.id ?? null);
    });
    return () => { active = false; subscription.unsubscribe(); };
  }, []);
  return actor ? JSON.stringify([actor, me?.organizationId, me?.role, me?.clinicIds]) : undefined;
}
